module.exports = new __parcel__URL__("compass.1c788776.svg").toString();